import {
  getCustomerHomeLegalEntity,
  getCustomerUuid,
} from '@camelot/webview-utils'
import { useLocalStorage } from '@vueuse/core'
import { defineStore, skipHydrate } from 'pinia'

export const useAppStore = defineStore('app', () => {
  // ---- State
  const accessToken = ref<string>('')

  // Use localStorage for state is possible, see https://pinia.vuejs.org/cookbook/composables.html#ssr
  const skipOnboarding = useLocalStorage('skipOnboarding', false)

  // ---- Getters
  const customerUuid = computed(() =>
    accessToken.value ? getCustomerUuid(accessToken.value) : undefined)

  const customerHomeLegalEntityId = computed(() =>
    accessToken.value ? getCustomerHomeLegalEntity(accessToken.value) : undefined)

  return {
    accessToken,
    customerUuid,
    customerHomeLegalEntityId,
    skipOnboarding: skipHydrate(skipOnboarding),
  }
})
